var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocalOffer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F26D0D",
  fillRule: "evenodd",
  d: "m3.335 11.106.18-5.615a3 3 0 0 1 .044-.413c.279-1.551 1.763-2.629 3.316-2.406l5.561.797.046-.039 7.746 9.232c.992 1.183.803 2.976-.423 4.004l-4.753 3.989c-1.226 1.028-3.024.903-4.016-.28l-7.747-9.231zm6.09-2.098c-.669.56-1.66.48-2.215-.182a1.57 1.57 0 0 1 .205-2.212c.668-.561 1.66-.48 2.215.181a1.57 1.57 0 0 1-.206 2.213",
  clipRule: "evenodd"
})));
export default SvgLocalOffer;